import { render, staticRenderFns } from "./CrosswordGame.vue?vue&type=template&id=c9b6e7bc&scoped=true"
import script from "./CrosswordGame.vue?vue&type=script&lang=js"
export * from "./CrosswordGame.vue?vue&type=script&lang=js"
import style0 from "./CrosswordGame.vue?vue&type=style&index=0&id=c9b6e7bc&prod&scoped=true&lang=css"
import style1 from "./CrosswordGame.vue?vue&type=style&index=1&id=c9b6e7bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b6e7bc",
  null
  
)

export default component.exports